import { REBUZZ_BOOSTS } from './rebuzzBoosts';
import { REBUZZ_SELECTED_OPTIONS } from '../components/Rebuzz/constants/rebuzzSelectedOptions';

export const DEFINED_BOOST_TAG = {
  [REBUZZ_BOOSTS.freeContent]: REBUZZ_SELECTED_OPTIONS.CONTENT,
  [REBUZZ_BOOSTS.content]: REBUZZ_SELECTED_OPTIONS.CONTENT,
  [REBUZZ_BOOSTS.freePromotion]: REBUZZ_SELECTED_OPTIONS.PROMOTION,
  [REBUZZ_BOOSTS.promotion]: REBUZZ_SELECTED_OPTIONS.PROMOTION,
};
